import Components from './components'
import Views from './views'
import Common from './common.json'
import Messages from './messages'

export default {
  Components,
  Views,
  Common,
  Messages
}
